import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ChaptersSection } from './components/ChaptersSection';
import { AuthorSection } from './components/AuthorSection';
import { CTASection } from './components/CTASection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-parchment-light text-brown-dark font-serif selection:bg-gold/30 selection:text-forest-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <AboutSection data-id="element-2" />
      <ChaptersSection data-id="element-3" />
      <AuthorSection data-id="element-4" />
      <CTASection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}